import React, { useContext, useEffect, useRef, useState } from "react";
import { registerCSS } from "./Register.css";
import { set, useForm } from "react-hook-form";
import { fetchRegister, fetchUser, validateTkn } from "../../Components/Functions/functions";
import { url, prod } from "../../env";
import { useLocation, useParams } from "react-router-dom";
import { Loader } from "../../Components";
import { Login } from "../Login/Login";
import { AuthContext } from "../../Context/AuthContext";
import { Toast } from "primereact/toast";
import { FormRegister } from "./components/FormRegister";
import OtpCode from "./components/OtpCode";
import { CANAL_SMS, CANAL_WHATSAPP, sendMessageOtp, validateOtp } from "./AuthOtp";
import axios from "axios";




function Register({ secret, setState, id, setStep }) {
  const [showOTP, setShowOTP] = useState(false);

  const [loading, setLoading] = useState(false);
  const [loadingOtp, setLoadingOtp] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const { authInfo, setUser, setAuthInfo } = useContext(AuthContext);

  const toast = useRef(null); // Inicializa el ref con useRef


  //si es prod mostrar otp
  let prodd = true;



  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const isShared = params.get('share') === 'true';
  const isSharedCode = params.get('share_code') === 'true';

  // Extraer el código de la URL
  const shareCode = location.pathname.split('/').pop();

  // si es una URL de compartir, no se hace la petición para redirigirte 
  useEffect(() => {
    if (shareCode && isShared) {

      // Lógica para cotización compartida
      axios.get(`${url}/getBudgetByShareCode`, {
        params: { share_code: shareCode }
      })
        .then(res => {
          if (res.data) {
            // Redirigir a la URL de continuación
            // Puedes usar window.location.href o history.push dependiendo de tu configuración de enrutamiento
            // Aquí rediriges al usuario a la URL de continuación
            window.location.href = res.data.continue_url;


          }
        })
        .catch(err => {
          console.log('Error fetching budget:', err);
        });
    }
  }, []);


  const [isRegisteredState, setIsRegisteredState] = useState({
    status: false,
    data: null,
  });

  useEffect(() => {
    const checkTokenAndFetchData = async () => {
      const token = localStorage.getItem("token");
      // Si ya tiene un token, es que ya está logueado
      if (token) {
        // Validar el token
        try {
          const result = await validateTkn(url, { secret, id });
          // setIsRegisteredState({
          //   status: true,
          //   data: null,
          //   valid: true,
          // });
          // debugger
          if (!result.valid) {
            setIsRegisteredState({
              // status: true,
              data: null,
              // token falso no valido
              valid: false,
            });
            localStorage.removeItem("token");
            setLoading(false);
          } else {
            setIsRegisteredState({
              status: true,
              data: null,
              valid: true,
            });
          }
          setLoading(false);
        } catch (error) {
          console.error("Error al validar el token:", error);
          setLoading(false);
        }
        // return
      }
      // Si no tiene token, proceder a hacer la petición
      const fetchData = async () => {
        setLoading(true);
        try {
          // comprobar si es una URL de share en este caso no se hace la petición de obtener datos de ususario
          const isSharedUrl = window.location.pathname.includes('/share/');
          // debugger
          if (secret) {  // Solo hacer la petición si NO es una URL de share
            const result = await fetchUser(url, { secret, id, type: "register" });
            if (result.isRegistered) {
              setAuthInfo(
                (prev) => ({
                  ...prev,
                  data: result,
                }
                ));
              setIsRegisteredState(prev => ({
                ...prev,
                status: true,
                data: result,
              }));
              // localStorage.setItem("token", result.token);
              setState((prev) => ({ ...prev, fetchUserData: result }));
              setLoading(false);
              return;
            }

            // si es una URL de share no se setean los datos del usuario 
            // ya que un nuevo usuario se registrara
            if (!isSharedCode) {

              setValue("email", result.email);
              setValue("name", result.name);
              setValue("phone", result.phone);

              setState((prev) => ({
                ...prev,
                email: result.email,
                name: result.name,
                loading: false,
              }));

            }

            setLoading(false);
          } else {
            setLoading(false);
          }
        } catch (error) {
          setState((prev) => ({ ...prev, loading: false }));
          setIsRegisteredState({
            status: false,
            data: null,
          });
          setLoading(false);
          toast.current.show({
            severity: 'error',
            summary: 'Error',
            detail: 'Error al procesar la solicitud. Inténtalo de nuevo.',
            life: 3000,
          });
        }
      };

      if (!authInfo.data) {
        await fetchData();
      }
    };

    checkTokenAndFetchData();
  }, []);


  const defaultValues = {
    email: '',
    password: '',
    confirmPassword: '',
    phone: '',
    otpCode: '',
  };

  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
    control,
    setValue,
    getValues,
  } = useForm({ defaultValues });



  const email = watch("email");

  const [message, setMessage] = useState("");

  // Canal por el que salió el último código, y lo que la pantalla del OTP
  // necesita mostrar (a qué número, cuándo se puede reenviar). El valor inicial
  // es solo un placeholder: el canal real lo dice la respuesta del servidor.
  const [canalOtp, setCanalOtp] = useState(CANAL_SMS);
  const [otpInfo, setOtpInfo] = useState({ telefonoMascarado: "", puedeReenviarEn: 60, sugerirSms: false });

  /**
   * ÚNICO camino para pedir un código: lo usan el alta, el "Reenviar" y el
   * "mándalo por SMS". Antes submit() y resendCode() lo hacían por separado y
   * ya habían divergido (uno comparaba response.response, el otro
   * +response.response).
   */
  const pedirCodigo = async (canal, { reenvio = false } = {}) => {
    const data = getValues();
    const newPhone = (data.phone || "").replace(/[^0-9]/g, '');
    const response = await sendMessageOtp({ phone: newPhone, email: data.email, canal, reenvio });

    if (response.ok) {
      // El backend puede caer de WhatsApp a SMS solo: se anuncia el canal REAL
      // y, si hubo cambio, se dice, o el usuario mira el WhatsApp en vano.
      const cayoASms = Boolean(response.canalSolicitado)
        && response.canalSolicitado !== response.canal;

      setCanalOtp(response.canal);
      setOtpInfo({
        telefonoMascarado: response.telefonoMascarado || "",
        puedeReenviarEn: response.puedeReenviarEn || 60,
        sugerirSms: false,
        cayoASms,
      });
      setShowOTP(true);
      toast.current.show({
        severity: 'success',
        summary: 'Éxito',
        detail: response.canal === CANAL_SMS ? 'Código enviado por SMS' : 'Código enviado por WhatsApp',
        life: 3000,
      });

      return true;
    }

    setMessage(response.message || "Ocurrió un error al enviar el código");
    toast.current.show({
      severity: 'error',
      summary: 'Error',
      detail: response.message || 'Ocurrió un error al enviar el código',
      life: 4000,
    });

    if (response.sugerirSms) {
      // Un fallo de WhatsApp es o "ese número no tiene WhatsApp" o un problema
      // nuestro (token, plantilla): el backend ya distingue cuál y manda el
      // texto. Se deja la pantalla del código abierta con el botón de SMS, en
      // vez de devolver al usuario al formulario sin decirle qué hacer.
      setOtpInfo((prev) => ({ ...prev, sugerirSms: true, mensajeFallo: response.message }));
      setShowOTP(true);
    } else if (response.motivo !== 'cooldown' && response.motivo !== 'demasiados_envios') {
      // El cooldown NO cierra la pantalla: el código anterior sigue vivo.
      setShowOTP(false);
    }

    return false;
  };

  const submit = async (data, type) => {
    setLoading(true);
    if (!prodd) {
      submitOtp();
      return;
    }
    // Sin canal: lo elige el servidor (whatsapp.otp.canal_default).
    await pedirCodigo(undefined);
    setLoading(false);
  };


  const handleOnchage = () => {
    setMessage("");
  };

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  const submitOtp = async (data = null) => {
    setLoadingOtp(true);

    try {
      // si es dev no pedir el otp
      if (!prodd) {
        const data = getValues();
        const result = await fetchRegister(url, { ...data, secret, id });

        if (result.status === 201) {
          setLoading(false);

          localStorage.setItem("token", result.token);
          setUser(result)
          setStep(3);
        } else {
          // mostrar error
          if (result === "The email has already been taken.") {
            toast.current.show({
              severity: 'success',
              summary: 'Éxito',
              detail: 'Usuario creado exitosamente',
              life: 3000,
            });
            setMessage("El correo ya ha sido registrado.");
            setLoading(false);
            return;
          }
          setMessage(result);
          setLoading(false);
          // setMessage();
        }
        return;
      }

      const newPhone = getValues('phone')
      const validacion = await validateOtp({ phone: newPhone, otp: (getValues('otp') || []).join('') });

      if (validacion.ok) {
        const data = getValues();
        const result = await fetchRegister(url, { ...data, secret, id });

        if (result.status === 201) {
          setLoading(false);

          localStorage.setItem("token", result.token);
          setUser(result)
          setStep(3);
        } else {
          // mostrar error
          if (result === "The email has already been taken.") {
            toast.current.show({
              severity: 'success',
              summary: 'Éxito',
              detail: 'Usuario creado exitosamente',
              life: 3000,
            });
            setMessage("El correo ya ha sido registrado.");
            setLoading(false);
            return;
          }
          setMessage(result);
          setLoading(false);
          // setMessage();
        }

      } else {
        // El motivo real (expirado / bloqueado / no solicitado) ya viene del
        // backend: repetir "OTP inválido" para los cuatro casos dejaba al
        // usuario tecleando otra vez un código que ya había caducado.
        throw new Error(validacion.message || 'El código no es correcto.');
      }
    } catch (error) {
      toast.current.show({
        severity: 'error',
        summary: 'Error',
        detail: error.response?.data?.message || error.message || 'Error al procesar la solicitud. Inténtalo de nuevo.',
        life: 3000,
      });

      // Es error del servidor o del OTP. Se concatenan los dos mensajes en vez
      // de encadenar `?.` sobre cada uno: la condición anterior llamaba
      // `error.response.data.message("contraseña")` —un string como función— y
      // reventaba DENTRO del catch en cuanto el backend respondía un 4xx con
      // mensaje.
      const detalle = [error.message, error.response?.data?.message]
        .filter((texto) => typeof texto === 'string')
        .join(' | ');

      if (detalle.includes("correo") || detalle.includes("contraseña") || detalle.includes("No se encontró cotización")) {
        setShowOTP(false);
      }
      // si el usuario ya esta registrado
      if (error.response?.data?.register && error.response?.data?.register === false) {
        setShowOTP(false);
      }
      // setShowOTP(false);
    } finally {
      setLoadingOtp(false); // Asegúrate de que siempre se desactive el estado de carga
    }
  };

  useEffect(() => {
    let phone = watch("phone");
    phone = phone.replace(/[^0-9]/g, '');

  }, [watch("phone"), watch()]);

  /** Sin argumento reenvía por el mismo canal; con CANAL_SMS cambia de canal. */
  const resendCode = async (canal = canalOtp) => {
    setLoadingOtp(true);
    setLoading(true);

    try {
      return await pedirCodigo(canal, { reenvio: true });
    } finally {
      setLoadingOtp(false);
      setLoading(false);
    }
  };

  return (isRegisteredState.status) ? (
    <Login isRegistered={isRegisteredState} setStep={setStep} secret={secret} id={id} setState={setState} />
  ) : (
    <div css={registerCSS()}>
      {(loading || loadingOtp) && <Loader />}
      <div className="flex flex-column align-items-center" style={{ display: "flex", justifyContent: "center", alignItems: "center", position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>

        <Toast ref={toast} />
        {/* <div className="font-semibold subtitle pb-3 text-center">
          ¡Bienvenido! Por favor, regístrate.
        </div> */}
        {
          showOTP && prodd ? (
            <OtpCode loading={loadingOtp} setShowOTP={setShowOTP} submitOtp={submitOtp} reset={reset} setValue={setValue} toast={toast} getValues={getValues} register={register} handleOnchage={handleOnchage} resendCode={resendCode} prodd={prodd} canal={canalOtp} otpInfo={otpInfo} enviarPorOtroCanal={() => resendCode(canalOtp === CANAL_SMS ? CANAL_WHATSAPP : CANAL_SMS)} />
          ) : (
            <FormRegister submit={submit} register={register} handleSubmit={handleSubmit} handleOnchage={handleOnchage} showPassword={showPassword} handleTogglePassword={handleTogglePassword} errors={errors} getValues={getValues} />
          )
        }
      </div>
    </div>
  );
}

export { Register };
